export default __webpack_public_path__ + "static/media/restaurant.dcf6f1f7.svg";